import { createElement } from 'react';
import './index.scss';
import { Drawer as NextDrawer, Button } from '@alifd/next';
const Drawer = ({ visible, title, placement, actions, children, onClick, ...otherProps }) => {
    const _otherProps = otherProps || {};
    return (createElement("div", { className: "drawer", ..._otherProps },
        createElement(NextDrawer, { visible: visible, title: title, placement: placement },
            children,
            createElement("div", { className: "drawer-actions", style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '16px',
                    padding: '16px',
                } }, actions &&
                actions.map((action, index) => (createElement("div", { key: index, className: "drawer-action" },
                    createElement(Button, { type: action.style, onClick: action.action }, action.text))))))));
};
Drawer.displayName = 'CustomDrawer';
export default Drawer;
